export const PAGE_VIEW = {
  PV: "pageview.invoice.pv", //html的pv
  LOGIN: "pageview.invoice.login", //登录页面

  SELECT_PAGE: "pageview.invoice.select", //发票选择页
  // SELECT_PAGE_ALLOW: "pageview.invoice.select_allow", //发票选择页-可开票
  // SELECT_PAGE_YEAR: "pageview.invoice.select_year", //发票选择页-近一年
  SELECT_PAGE_ALL: "pageview.invoice.select_all", //发票选择页-近一年

  TITLE_INDIVIDUAL: "pageview.invoice.individual", //开票-个人
  TITLE_ORG: "pageview.invoice.org", //开票-组织
  TITLE_CO: "pageview.invoice.Co", //开票-公司
  TITLE_SP: "pageview.invoice.Sp", //开票-专票

  APPLY_SUCCESS: "pageview.invoice.success", //申请成功页

  RECORD_PAGE: "pageview.invoice.record", //开票记录
  RECORD_DETAIL: "pageview.invoice.record_details", //开票记录详情
  INVOICE_RESULT: "pageview.invoice.result" //开票结果页
}

export const CLICK = {
  LOGIN_QQ: "click.invoice.login_switch_qq", //登录页面点击切换qq
  LOGIN_WX: "click.invoice.login_switch_wx", //登录页面点击切换微信
  APPLY: "click.invoice.login_apply", //登录页面点击申请发票
  RECODRD: "click.invoice.login_record", //登录页面点击开票记录

  TIME_SELECT_START: "click.invoice.select_time_start", //发票选择页选择开始时间
  TIME_SELECT_END: "click.invoice.select_time_end", //发票选择页选择结束时间
  TIME_CANCEL: "click.invoice.select_time_cancel", //发票选择页选择时间然后取消

  // ALLOW_TAB: "click.invoice.select_allow_tab", //发票选择页点击可开票
  // YEAR_TAB: "click.invoice.select_year_tab", //发票选择页点击近一年
  SELECT_NEXT: "click.invoice.select_next", //发票选择页点击下一步
  SELECT_NOTE: "click.invoice.select_note", //发票选择页点击查看详情
  SELECT_ORDER: "click.invoice.select_order", //发票选择页选择订单进行开票

  TITLE_INDIVIDUAL_TAB: "click.invoice.title_individual_tab", //发票抬头页点击个人
  TITLE_ORG_TAB: "click.invoice.title_org_tab", //发票抬头页点击组织
  TITLE_CO_TAB: "click.invoice.title_Co_tab", //发票抬头页点击公司
  COMMIT_INDIVIDUAL: "click.invoice.commit_individual", //开票-个人点击提交
  COMMIT_ORG: "click.invoice.commit_org", //开票-组织点击提交
  COMMIT_CO: "click.invoice.commit_Co", //开票-公司点击提交
  COMMIT_SP: "click.invoice.commit_Sp", //开票-专票点击提交

  COMMIT_FAIL_RETURN: "click.invoice.commit_fail_return", //开票失败（全部订单都无法开发票-已开票或开票中或全额退款）弹窗点击我知道了，
  COMMIT_FAIL_CANCEL: "click.invoice.commit_fail_cancel", //开票失败弹窗点击取消，
  COMMIT_FAIL_CONTINUE: "click.invoice.commit_fail_continue", //开票失败弹窗点击继续开发票，
  COMMIT_FAIL_AMEND: "click.invoice.commit_fail_amend", // 开票失败，敏感词错误点击确认

  SUCCESS_RETURN: "click.invoice.success_return_home", //申请成功页点击返回首页
  SUCCESS_SUBSCRIBE: "click.invoice.success_subscribe", //申请成功页点击订阅公众号
  SUCCESS_UNSUBSCRIBE: "click.invoice.success_unsubscribe", //申请成功页点击取消订阅公众号

  LOOK_RECORD_DETAIL: "click.invoice.look_recorddetail", //开票记录-右箭头
  LOOK_QRCODE: "click.invoice.look_qrcode", //点击查看电子发票

  SEND_EMALIL: "click.invoice.send_email", // 点击发送邮件
  DOWNLOAD_INVOICE_PDF: "click.invoice.download_invoice_pdf", // 点击下载发票PDF文件
  DOWNLOAD_INVOICE_XML: "click.invoice.download_invoice_xml", // 点击下载发票XML文件
  DOWNLOAD_INVOICE_DOC: "click.invoice.download_invoice_doc" // 点击下载发票DOC文件
}

export const ERROR = {
  GENERATE_QRCODE: "error.invoice.generate_qrcode", //链接转二维码出错
  COMMIT_FAIL: "error.invoice.commit_fail", //开票失败
  COMMIT_FAIL_HASINVOICED: "error.invoice.commit_fail_hasinvoiced", //开票失败——已开票
  COMMIT_FAIL_AMOUNTERROR: "error.invoice.commit_fail_amounterror", //开票失败——开票金额错误
  COMMIT_FAIL_SENSITIVEWORD: "error.invoice.commit_fail_sensitiveword", //开票失败——敏感词
  SEND_EMAIL_FAIL: "error.invoice.send_email_fail", // 发送邮件失败
  WXBEAN_VERIFY_FAIL: "error.invoice.wxbean_verify_fail" // 微信豆获取登陆态失败
}

export const SUCC = {
  COMMIT_SUCC: "succ.invoice.commit_succ", //开票成功
  SEND_EMAIL_SUCC: "succ.invoice.send_email_succ", // 发送邮件成功
  WXBEAN_VERIFY_SUCC: "succ.invoice.wxbean_verify_succ" // 微信豆获取登陆态成功
}

export const PF = {
  WX_RESULT: "__mds_wxservice_tips_invoiceresult", //来源：微信公众号结果通知tips
  QQ_RESULT: "__mds_qqservice_tips_invoiceresult" //来源：QQ公众号结果通知tips
}
